import * as React from 'react';
import { useTheme } from '@fluentui/react-theme-provider/lib/compat';
import { AppThemeManager } from '../AppThemeManager';
export var AppThemeConsumer = function (props) {
    var theme = useTheme() || AppThemeManager.getInstance().getTheme();
    return React.createElement(React.Fragment, null, props.children(theme));
};
//# sourceMappingURL=AppThemeConsumer.js.map